angular
  .module('data-ng-todos')
  .factory('PlacementTestScoresBuilder', function PlacementTestScoresBuilder(Interface, CourseBuilder) {
    'use strict';

    var _CourseBuilder = CourseBuilder;
    var PlacementTestScoresDTD = {
      placementsection: {
        type: 'object',
        typeDef: {
          id: 'key',
          name: 'string',
          dev_course_ids_by_group_nk: 'object',
          test_subject_ids: 'array',
          test_subject_ids_on_path: 'array',
          next_highest_path_entry_by_group_nk: 'object',
          best_test_subject_ids_by_group_nk: 'object',
          _courses_by_group_nk: 'array',
          _tests: 'array',
          _best_tests_by_nk: 'object',
          _path_tests: 'array',
          _tests_on_path: 'array',
          _tests_off_path: 'array'
        },
        writeToKey: 'placement_sections'
      },
      testsubject: {
        type: 'object',
        typeDef: {
          id: 'key',
          name: 'string',
          score: 'number',
          max_score: 'number'
        },
        writeToKey: 'test_subjects'
      },
      course: {
        type: 'object',
        typeDef: {
          id: 'key',
          title: 'string',
          desc: 'string',
          cd: 'string'
        },
        writeToKey: 'courses'
      },
      placementcenter: {
        type: 'ngArray',
        typeDef: 'GeoJsonBuilder',
        writeToKey: 'placement_locations'
      }
    };

    // Creating a hash map of the test subjects is much more efficient than repeated _.find() calls.
    // Also, several functions can benefit from reusing a single hash map.
    var testSubjectMap = {};

    function PlacementTestScoresDTO(data) {
      Interface.implement(PlacementTestScoresDTD, data, this);

      testSubjectMap = _.indexBy(this.test_subjects, 'id');

      _.forEach(
        data.placementsection,
        function (placementSection) {
          extractCoursesFromIds.call(this, placementSection);
          extractTestsFromIds.call(this, placementSection);
          extractPathTestsFromIds.call(this, placementSection);
          extractBestTestsFromIds.call(this, placementSection);
          extractTests.call(this, placementSection);
        },
        this
      );
    }

    var extractCoursesFromIds = function (placementSection) {
      var courseMap = _.indexBy(this.courses, 'id');

      _.forEach(placementSection.dev_course_ids_by_group_nk, function (dev_course_ids, group_nk) {
        var devCourses = [];

        _.forEach(dev_course_ids, function (dev_course_id) {
          devCourses.push(courseMap[dev_course_id]);
        });

        placementSection._courses_by_group_nk[group_nk] = devCourses;
      });
    };

    var extractTestsFromIds = function (placementSection) {
      _.forEach(placementSection.test_subject_ids, function (test_subject_id) {
        placementSection._tests.push(testSubjectMap[test_subject_id]);
      });
    };

    var extractPathTestsFromIds = function (placementSection) {
      _.forEach(placementSection.test_subject_ids_on_path, function (test_subject_id) {
        placementSection._path_tests.push(testSubjectMap[test_subject_id]);
      });
    };

    var extractBestTestsFromIds = function (placementSection) {
      _.forEach(placementSection.best_test_subject_ids_by_group_nk, function (test_subject_ids, group_nk) {
        var testSubjectsList = [];

        _.forEach(test_subject_ids, function (test_subject_id) {
          var testSubject = testSubjectMap[test_subject_id];

          if (!_.isUndefined(testSubject)) {
            testSubjectsList.push(testSubject);
          }
        });

        placementSection._best_tests_by_nk[group_nk] = testSubjectsList;
      });
    };

    var categorizeTests = function (placementSection) {
      var onPath = [];
      var offPath = [];

      _.forEach(placementSection._tests, function (test) {
        if (placementSection._path_tests.indexOf(test) != -1) {
          onPath.push(test);
        } else {
          offPath.push(test);
        }
      });

      return {
        onPath: onPath,
        offPath: offPath
      };
    };

    var extractTests = function (placementSection) {
      var tests = categorizeTests(placementSection);

      placementSection._tests_on_path = tests.onPath;
      placementSection._tests_off_path = tests.offPath;
    };

    return PlacementTestScoresDTO;
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-todos/src/data/builders/placement_test_scores_builder.es.js